module.exports = __webpack_public_path__ + "img/02.d6456989.png";